module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard-step2.a99fe848.png";